sessionStorage.setItem('pslp', true);

if (location.href.indexOf('pslp-weekend=true') > -1 || sessionStorage.getItem('pslp-weekend') == 'true' && location.href.indexOf('pslp-weekend=false') == -1){
  sessionStorage.setItem('pslp-weekend', true);
  document.body.classList.add('pslp-weekend');
  document.querySelector(".pbrealprice").innerHTML = "&nbsp;$49.95";
  document.querySelector(".sticky-footer-price").innerHTML = document.querySelector(".sticky-footer-price").innerHTML.replace("59.96", "49.95");
}
else if (location.href.indexOf('pslp-weekend=false') > -1 || sessionStorage.getItem('pslp-weekend') == null){ sessionStorage.setItem('pslp-weekend', false); }

// SLICK SLIDER FOR MAIN IMAGES
$(document).ready(function(){
  $('.main-image-display').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, /* Main slider usually doesn't need arrows */
    fade: false,
    dots: true,
    focusOnSelect: false,
    infinite: true
  });

});


//STICKY FOOTER FUNCTIONS STOLEN FROM PDP, THEN CONVERTED TO VANILLA
function isDesktop() {
    var desktopWidth = 768;
    return window.innerWidth > desktopWidth;
}

document.addEventListener('DOMContentLoaded', function () {
    toggleStickyFooter();
    window.addEventListener('scroll', toggleStickyFooter);
});

function toggleStickyFooter() {
    var section01Containers = document.querySelectorAll('.sec01-cta-container');
    var ctaContainers = document.querySelectorAll('.sticky-footer-ctr');

    section01Containers.forEach(function (container) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var elementOffset = container.getBoundingClientRect().top + scrollTop;
        var distance = elementOffset - scrollTop;

        if (distance <= 0) {
            ctaContainers.forEach(function (cta) {
                cta.classList.remove('hide');
            });
        } else {
            ctaContainers.forEach(function (cta) {
                cta.classList.add('hide');
            });
        }
    });
}



//DISABLE THE CTA AFTER CLICKING IT SO PEOPLE KNOW SOMETHING IS HAPPENING
document.body.addEventListener("click", function (event) {
  if (event.target && event.target.id === "proceed-to-checkout") {
    event.target.classList.add("disabled");
  }
});

document.body.addEventListener("click", function (event) {
  if (event.target && event.target.id === "sticky-footer-proceed-to-checkout") {
    event.target.classList.add("disabled");
  }
});



// SCRIPT FOR ADDING PRODUCT TO CART

var after_addcart_url = window.shopUrl + "/checkout";
var promises = [];
var isClicked = false;

var product_handle, product, selling_plan_id, sas_variant, pre_upsell_variant_sas, pre_upsell_variant_selector, pre_upsell_product_sas, variant_sku, variant_name, preupsell_url, product_cart_language, product_pricebook, uniqueKey;
const uniqueId = crypto.randomUUID();

async function pslp_add_to_cart(product_handle, product, selling_plan_id, sas_variant, pre_upsell_variant_sas, pre_upsell_variant_selector, pre_upsell_product_sas, variant_sku, variant_name, preupsell_url = "", product_cart_language = "", product_pricebook = "", sas_free_gift, uniqueKey) {

      document.getElementById('proceed-to-checkout').classList.add('disabledCTA');

      if (preupsell_url != "") {
        after_addcart_url = preupsell_url;
      }
      var return_message = "";
      var preupsell_variants = pre_upsell_variant_sas;
      let sasCartAttributes = {};
      var selling_plan = "entry";
      if (selling_plan_id == "") {
        var selling_plan = "";
        var cart_language = "";
      } else {
        var cart_language = product_cart_language;
      }
      var productpricebook = window.campaign_pricebook
      if (product_pricebook != "") {
        productpricebook = product_pricebook
      }
      if (!isClicked) {
        isClicked = true;
        window.custom_add_to_cart = true;
        if (preupsell_variants == "") {
          if (cart_language != "") {

            var subscription_terms = {
              "_subscription_terms": cart_language,
              "_pricebook": productpricebook
            }
          } else {
            var subscription_terms = {}
          }
          if ((preupsell_url != "") && (pre_upsell_product_sas != "")) {
            var preupsell_prop = {
              "_preupsell_link": preupsell_url,
              "_preupsell_product": pre_upsell_product_sas,
              "_preupsell_product_selling_plan": selling_plan,
              "_preupsell_add_or_upgrade_cart": "upgrade"
            };
          } else {
            var properties_sas = {}
          }
          var properties_sas = Object.assign({ "_product_from_PDP": "NOT_PDP", "_from_sas": "true" }, preupsell_prop, subscription_terms);
        } else {
          if (cart_language != "") {
            var subscription_terms = {
              "_subscription_terms": cart_language,
              "_pricebook": productpricebook
            }
          } else {
            var subscription_terms = {}
          }

          if ((preupsell_url != "") && (pre_upsell_product_sas != "")) {
            var preupsell_prop = {
              "_preupsell_link": preupsell_url,
              "_preupsell_product": pre_upsell_product_sas,
              "_preupsell_product_selling_plan": selling_plan,
              "_preupsell_variants": preupsell_variants,
              "_preupsell_add_or_upgrade_cart": "upgrade"
            };
          } else {
            var preupsell_prop = {};
          }
          var properties_sas = Object.assign({ "_product_from_PDP": "NOT_PDP", "_from_sas": "true" }, preupsell_prop, subscription_terms);
        }

        // Free gift info for populating order metafields
        var freeGiftInfo = [];
        sas_free_gift.forEach((item) => {
          freeGiftInfo.push(item.id + ":" + item.title);
        });

        properties_sas["_free_gift_info"] = freeGiftInfo;
        properties_sas["_line_item_id"] = uniqueKey; // unique key for kit-free gift reference

        await fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(async (data) => {
            var items = data.items;
            var filteredItems = [];
            var checkPreupsellQuantity = [];
            var maxAllowedGift = false
            if (selling_plan_id != "") {
              filteredItems = items.filter(item => item.properties._subscription_terms !== undefined  && item.id === parseInt(product));
            } else {
              filteredItems = items.filter(item => item.properties._subscription_terms === undefined  && item.id === product);
            }

            if (preupsell_variants != '') {
              checkPreupsellQuantity = items.filter(item => item.properties._subscription_terms !== undefined  && item.id === parseInt(preupsell_variants));
            }

            if( sas_free_gift.length > 0 ) {
              sas_free_gift.forEach(gift => {
                const filteredFreeGiftInCart = items.filter(item => 
                  item.properties?._free_gift && 
                  item.properties._free_gift === gift.properties._free_gift &&
                  item.id == gift.id
                );
                if(filteredFreeGiftInCart.length >= 3) {
                  maxAllowedGift = true;
                }
              })
            }
            if (filteredItems.length < 3 && checkPreupsellQuantity.length < 3 && !maxAllowedGift) {
              // If preupsell qualified product, then update the selected cart key for SAS cart attributes
              if( preupsell_url != "" ) {
                sasCartAttributes["_sas_selected_cart_key"] = product + ":" + selling_plan_id,
                sasCartAttributes["_from_sas"] = "true"
              } else {
                sasCartAttributes["_from_sas"] = ""
              }

              var post_data = {
                quantity: 1,
                id: product,
                selling_plan: selling_plan_id,
                properties: properties_sas
                
              }

              var updated_post_data;
              if(sas_free_gift){
                updated_post_data = [post_data, ...sas_free_gift];
              } else {
                updated_post_data = [post_data];
              }

              try {
                const sasNewAddToCartResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Operation-Type': 'SAS/AddToCart'
                  },
                  body: JSON.stringify({items: updated_post_data, attributes: sasCartAttributes, sections: ["cart-drawer", "cart-icon-bubble"]})
                })
                const data = await sasNewAddToCartResponse.json();
                await CartAPIController.applyProductAddOns(false, null, null, data.sections? data.sections : null) // Apply product add-ons if any for the sas add to cart

                // Preupsell/checkout redirection logic
                if ("{{ request.locale.iso_code }}" == "es") { preupsell_url = ""; }

                if (preupsell_url != "") {
                  window.location.href = preupsell_url;
                  isClicked = false;
                } else {
                  window.location.href = window.shopUrl + "/checkout";
                  isClicked = false;
                }
              } catch (error) {
                console.log('Fetch error:', error);
                document.querySelectorAll(".sas-page-kits-section").forEach(el => {
                  el.insertAdjacentHTML(
                    "beforeend",
                    `<span class="error-msg" style="text-align: center; display: block; color:red;">${error}</span>`
                  );
                });
                isClicked = false;
              }
            } else {
              if (preupsell_url != "" && checkPreupsellQuantity.length < 3 && !maxAllowedGift ) {
                window.location.href = preupsell_url;
                isClicked = false;
              } else {
                window.location.href = window.shopUrl + "/checkout";
                isClicked = false;
              }
            }
          });
      }
      try{ document.getElementById('proceed-to-checkout').classList.remove('disabledCTA'); }catch(e){}
      return return_message;
    }
	
	
document.addEventListener('DOMContentLoaded', function () {



  // Handle "Proceed to Checkout" button click
  var proceedButton = document.getElementById('proceed-to-checkout');
  proceedButton.addEventListener('click', async function (event) {
    event.preventDefault();



    //SET THE IDs BASED ON INSTANCE, STARTING WITH STAGING IDs
    let _pslpProductHandle = "anti-aging-face-neck-skincare-system";
    let _pslpProductID = "51865729794342";
    let _pslpSellingPlanID = "11042292006";
    let _pslpSASVariant = [51770762920230, 49964740706598];
    let _pslpPreupsellVariantSAS = "51865787072806";
    const _pslpPreupsellVariantSelector = true;
    let _pslpPreupsellProductSAS = "anti-aging-face-neck-skincare-system-with-revive-brighten-eye-masque";
    let _pslpVariantSKU = "MT.B00090";
    const _pslpVariantName = "Anti-Aging Face & Neck Skincare System";
    //const _pslpPreupsellURL = "/pages/preupsell-rbem"; MAKING THIS BLANK BYPASSES THE UPSELL.  LEAVING ALL THE EXTRA DATA HERE FOR REFERENCE IN THE FUTURE.
    const _pslpPreupsellURL = "";
    const _pslpProductCartLanguage = "One month after your first order is shipped, and then approximately every three months thereafter, you will be sent a full size supply of Meaningful Beauty®. Each shipment will be charged to the payment method you provide today, in three monthly payments of $79.95 plus $4.99 for shipping and handling charges unless you call (800) 927-0047 or visit www.meaningfulbeauty.com/account to manage or cancel your subscription.";
    const _pslpPricebook = "MB849-79Hair34-54PB";

    //SET VALUES FOR STAGING WEEKEND
    if (sessionStorage.getItem('pslp-weekend') == "true"){
      _pslpProductHandle = "anti-aging-face-neck-skincare-system-sale";
      _pslpProductID = "51916483264806";
      _pslpSellingPlanID = "11052089638";
      _pslpPreupsellVariantSAS = "51916767756582";
      _pslpVariantSKU = "MT.B00092";
      _pslpPreupsellProductSAS = "anti-aging-face-neck-skincare-system-with-revive-brighten-eye-masque-sale";
    }

    let _pslpSelectedGiftItems = [
      { "id":"51876313628966", "title":"Youth Activating Smoothing and Refreshing Eye Serum", properties: { _free_gift: true, _qualifying_product: _pslpProductID, _qualifying_line_item_id: _pslpProductID + ":" + _pslpSellingPlanID + ":" + uniqueId }},
      { "id":"51876309664038", "title":"Hydrating and Soothing Facial Mist", properties: { _free_gift: true, _qualifying_product: _pslpProductID, _qualifying_line_item_id: _pslpProductID + ":" + _pslpSellingPlanID + ":" + uniqueId }}
    ];
    

    //SET VALUES FOR PRODUCTION
    if (location.href.indexOf('meaningfulbeauty.com') > -1){
      _pslpProductID = "51854948368665";
      _pslpSellingPlanID = "691534102809";
      _pslpSASVariant = [51770389659929, 50179773038873];
      _pslpPreupsellVariantSAS = "51854981431577";

        //SET VALUES FOR PRODUCTION WEEKEND
        if (sessionStorage.getItem('pslp-weekend') == "true"){
          _pslpProductHandle = "anti-aging-face-neck-skincare-system-sale";
          _pslpProductID = "51869085532441";
          _pslpSellingPlanID = "691537674521";
          _pslpPreupsellVariantSAS = "51869179117849";
          _pslpVariantSKU = "MT.B00092";
          _pslpPreupsellProductSAS = "anti-aging-face-neck-skincare-system-with-revive-brighten-eye-masque-sale";
        }

      _pslpSelectedGiftItems = [
        { "id":"51852778897689", "title":"Youth Activating Smoothing and Refreshing Eye Serum", properties: { _free_gift: true, _qualifying_product: _pslpProductID, _qualifying_line_item_id: _pslpProductID + ":" + _pslpSellingPlanID + ":" + uniqueId }},
        { "id":"51852789940505", "title":"Hydrating and Soothing Facial Mist", properties: { _free_gift: true, _qualifying_product: _pslpProductID, _qualifying_line_item_id: _pslpProductID + ":" + _pslpSellingPlanID + ":" + uniqueId }}
      ];
    }

    const _pslpUniqueKey = _pslpProductID + ":" + _pslpSellingPlanID + ":" + uniqueId;

    pslp_add_to_cart(_pslpProductHandle, _pslpProductID, _pslpSellingPlanID, _pslpSASVariant, _pslpPreupsellVariantSAS, _pslpPreupsellVariantSelector, _pslpPreupsellProductSAS, _pslpVariantSKU, _pslpVariantName, _pslpPreupsellURL, _pslpProductCartLanguage, _pslpPricebook, _pslpSelectedGiftItems , _pslpUniqueKey);

  });

  //STICKY FOOTER CLICKS THE MAIN CTA
  document.getElementById("sticky-footer-proceed-to-checkout").addEventListener("click", function () {
    document.getElementById("proceed-to-checkout").click();
  });

  //CHANGE HEADER LINK TO LANDING PAGE
  document.querySelector(".header__heading-link").setAttribute("href","/pages/anti-aging-face-neck-skincare-system");
  document.querySelector(".promostrip-container a").setAttribute("href","/pages/anti-aging-face-neck-skincare-system");
  //CHANGE RIBBON TEXT
  document.querySelector(".promostrip-wrapper").innerHTML = "<strong>Over 20,000 5-Star Reviews</strong>";
  
});